import { prop, propOr, toLower } from 'ramda';

export const getBeneficiaryType = (getMiddleText, grantee) => {
  const granteeType = getMiddleText(`BENEFICIAIRE_TYPE_${grantee.type}_LABEL`);
  const granteeFirstName = propOr('', 'firstName', grantee);

  const granteeLabel = `${granteeFirstName} (${toLower(granteeType)})`;

  return {
    label: granteeLabel,
    value: prop('id', grantee)
  };
};
